import { render, staticRenderFns } from "./ProcedureTemporaryLow.vue?vue&type=template&id=3d39c9f9"
import script from "./ProcedureTemporaryLow.vue?vue&type=script&lang=js"
export * from "./ProcedureTemporaryLow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports